"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getListPrice = void 0;

var _request = _interopRequireDefault(require("./request"));

var getListPrice = function getListPrice(fulfillerId, onGetAccessToken) {
  var sellerid = "sellerId=".concat(fulfillerId);
  var sellerType = "sellerType=fulfillers";
  return (0, _request.default)("https://shippingprice.financialflows.cimpress.io/api/v1/listPrices?".concat(sellerid, "&").concat(sellerType), onGetAccessToken);
};

exports.getListPrice = getListPrice;